import { Tier0WelcomeUnlockCard, TIER_0_WELCOME_CATALOG_BUTTON_STYLE, TIER_0_UNLOCK_RED_AMBIENT_GRADIENT } from './Tier0WelcomeUnlockCard';
import { TIER_0_WELCOME_UNLOCK_REWARDS_CTA } from './tier0WelcomeHubCopy';
import { Tier0LockedTierPreviews, type BuildLadderInput } from './tier0LockedTierPreviews';
import type { TierLadderEntry } from '../../../../services/rewards/RewardsService';

const PLAYCAST_REWARDS_GOLD = '#FBBF24';

interface TierDisplayInfo {
  tierId: string;
  name: string;
  earnRateDescription?: string;
  maxEarningsDescription?: string;
}

interface NextTierDisplayInfo extends TierDisplayInfo {
  componentChecks?: unknown[];
}

interface WelcomeToPlaycastTier0Props {
  tier: TierDisplayInfo;
  nextTier: NextTierDisplayInfo | null;
  /** Live tier collection for the rungs above the next one. */
  ladder?: TierLadderEntry[];
  onOpenCatalog: () => void;
  onLearnMore: () => void;
}

/**
 * Tier 0 onboarding welcome shell — edit layout and copy here.
 */
export const WelcomeToPlaycastTier0 = ({ tier, nextTier, ladder = [], onOpenCatalog, onLearnMore }: WelcomeToPlaycastTier0Props) => {
  const welcomeLine1 = 'Welcome to';
  const welcomeLine2 = 'Playcast Rewards';
  const heroUrl = '/playcast-gibber.svg';
  const catalogLabel = 'Catalog';
  const unlockCta = TIER_0_WELCOME_UNLOCK_REWARDS_CTA;

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        padding: '8px 0px',
        background: '#0b0618',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', alignItems: 'center', flexShrink: 0 }}>
        <img src={heroUrl} alt="" style={{ width: 48, height: 48, marginBottom: 4 }} />
        <p style={{ margin: 0, color: '#ffffff', fontSize: 20, lineHeight: '24px', fontWeight: 700, textAlign: 'center' }}>
          {welcomeLine1}
          <br />
          <span style={{ color: PLAYCAST_REWARDS_GOLD }}>{welcomeLine2}</span>
        </p>
      </div>

      <div
        className="hr-scroll"
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          paddingTop: 24,
          paddingLeft: 0,
          paddingRight: 6,
          gap: 8,
          width: 'calc(100% + 6px)',
          scrollbarGutter: 'stable both-edges',
        }}
      >
        <Tier0WelcomeUnlockCard
          onLearnMore={onLearnMore}
          unlockCtaLabel={unlockCta}
          ambientGradient={TIER_0_UNLOCK_RED_AMBIENT_GRADIENT}
        />

        <Tier0LockedTierPreviews
          nextTier={nextTier}
          ladder={ladder}
          assignedTierId={tier.tierId}
        />
      </div>

      <div style={{ width: '100%', flexShrink: 0, paddingTop: 8 }}>
        <button type="button" onClick={onOpenCatalog} className="rewards-catalog-shine-button" style={TIER_0_WELCOME_CATALOG_BUTTON_STYLE}>
          {catalogLabel}
        </button>
      </div>
    </div>
  );
};
